import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createStateSyncMiddleware, initMessageListener } from 'redux-state-sync';
import { loadStorage, saveStorage } from 'utils/localStorage';
import { IApplicationState } from './state/app-state';
import rootReducer from './reducers/root-reducer';

const middlewares = [
    createStateSyncMiddleware({
        broadcastChannelOption: { type: 'localstorage' },
        channel: `${process.env.REACT_APP_PORTAL_NAME}-patient-redux-sync`,
    }),
];
const persistentState: IApplicationState = loadStorage();
const store = createStore(rootReducer, persistentState, composeWithDevTools(applyMiddleware(thunk, ...middlewares)));

store.subscribe(() => {
    saveStorage(store.getState());
});

initMessageListener(store);

export default store;
